import { getCurrentRoutePath } from '@/utils/route';
import Request from './axios';
import config from '../const/config';

const API = config.SERVICE_API;

/**
 * 默认获取用户信息路由白名单
 */
const AUTO_GET_USERINFO_WHITE_ROUTE_LIST = [
  '/one-yuan-welfare-card/buy',
  '/one-yuan-welfare-card/mine',
];

/** 判断是否需要默认获取用户信息 */
const getIsNeedAutoGetUserInfo = () => {
  const routePath = getCurrentRoutePath();
  return !AUTO_GET_USERINFO_WHITE_ROUTE_LIST.includes(routePath);
};


/**
 * 获取用户信息
 * @param {Object} data
 */
export async function getUserInfo(data) {
  // 获取用户信息白名单处理，外部引用较多，所以直接在接口定义处做白名单拦截
  if (getIsNeedAutoGetUserInfo()) {
    return Request.post(
      API,
      {
        action: 'switchpower.user.info',
        ...data,
      },
      {
        cacheKey: 'switchpower.user.info',
      },
    ).then((r) => r.data);
  }
  return Promise.resolve({});
}

/**
 *  查询用户协议
 */
export async function getProtocol(data) {
  return Request.post(
    API,
    {
      action: 'switchpower.user.protocol.v2',
      ...data,
    },
    {
      cacheKey: 'switchpower.user.protocol.v2',
    },
  ).then((r) => r.data);
}

/**
 *  获取学生认证信息
 */
export async function getApproveInfo(data) {
  return Request.post(
    API,
    {
      action: 'switchpower.student.approve.info',
      ...data,
    },
    {
      toastOnError: false,
    },
  );
}

/**
 *  查询用户实名认证信息
 */
export async function getUserRealInfo(data) {
  return Request.post(API, {
    action: 'switchpower.user.find.realname',
    ...data,
  }).then((r) => r.data);
}

/**
 *  是否有未绑定电池
 * yapi: https://yapi.hellobike.cn/project/1649/interface/api/222424
 */
export async function getIfBatteryBind(data) {
  return Request.post(API, {
    action: 'switchpower.user.order.noBatteryBind',
    ...data,
  }).then((r) => r.data);
}
/**
 *  查询用户实名认证信息
 * yapi: https://yapi.hellobike.cn/project/1649/interface/api/271979
 */
export async function getUserAuthentication(data) {
  return Request.post(API, {
    action: 'sw.user.realNameAuthCheck',
    ...data,
  }).then((r) => r.data || {});
}
